module.exports = __webpack_public_path__ + "img/aaron_image.3d84e2f5.jpg";